import { CommonButton } from '@Components/common/Button';
import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 43px;
`;

export const Title = styled.h6`
  padding: 18px 52px 35px 52px;
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  background-color: ${({ theme }) => theme.colors.innerProduct.gray};
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  padding: 58px 52px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  max-width: 776px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 34px;
`;

export const Label = styled.label`
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
`;

export const InputWrapper = styled.div`
  max-width: 567px;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  border-radius: 4px;
  padding: 0 16px 0 30px;
`;

export const Input = styled.input`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  border: none;
  width: 100%;
  &[type='date'] {
    /* flex-direction: row-reverse; */
    /* justify-content: space-between; */
    /* background-color: red; */
    ::-webkit-inner-spin-button {
      display: none;
    }
    ::-webkit-calendar-picker-indicator {
      background-color: white;
    }

    ::-webkit-datetime-edit-text {
      color: #555555;
    }
    ::-webkit-datetime-edit-month-field {
      color: #555555;
    }
    ::-webkit-datetime-edit-day-field {
      color: #555555;
    }
    ::-webkit-datetime-edit-year-field {
      color: #555555;
    }
    ::-webkit-calendar-picker-indicator {
      background-image: url('/calendar.svg');
      background-position: center;
      background-size: 20px 20px;
      background-repeat: no-repeat;
      color: rgba(204, 204, 204, 0);
    }
  }
`;

export const Error = styled.p`
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(120%);
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.brandColor};
`;

export const Button = styled(CommonButton)`
  width: 190px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  border: none;
  background-color: ${({ theme }) => theme.colors.brandColor};
  margin-left: auto;
`;

export const FormError = styled.p`
  text-align: center;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.brandColor};
`;
